import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import ProductAddForm from "./ProductAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const ProductsAdd = () => {
  return (
    <Layout pageTitle="Add Product">
      <Container>
        <Content>
          <ProductAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default ProductsAdd;
